import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
	sortDirection: boolean | null;
	sortFieldName: string | null;
}

const initialState: IInitialState = {
	sortDirection: false,
	sortFieldName: null,
};

const dashboardPOStatusesTable = createSlice({
	name: 'dashboardPOStatusesTable',
	initialState,
	reducers: {
		setSort: (
			state,
			action: PayloadAction<{
				sortDirection: boolean | null;
				sortFieldName: string | null;
			}>,
		) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		resetDashboardPOStatusesTable: () => initialState,
	},
});

export const {
	resetDashboardPOStatusesTable,
	setSort,
} = dashboardPOStatusesTable.actions;

export default dashboardPOStatusesTable.reducer;
